import { FormGridField } from "../../components/FormGrid";

export interface ButtonSelectorDefinition {
    name: string;
    id: string;
    label: string;
    items: { label: any; value: string | number }[];
    schemaName: string;
    exclusive?: boolean;
    fieldOverrides?: any;
    buildFormGridField: (schema) => FormGridField;
}

export default function buildButtonSelectorDefinition({
    name,
    id,
    label,
    items,
    schemaName,
    exclusive,
    fieldOverrides
}: {
    name: string;
    id: string;
    label: string;
    items: { label: any; value: string | number }[];
    schemaName: string;
    exclusive?: boolean;
    fieldOverrides?: any;
}): ButtonSelectorDefinition {
    return {
        name,
        id,
        label,
        items,
        schemaName,
        exclusive,
        fieldOverrides,
        buildFormGridField: _createButtonSelectorField
    };
}

function _createButtonSelectorField(schema): FormGridField {
    const {
        name,
        id,
        label,
        items,
        schemaName,
        exclusive,
        fieldOverrides
    } = this;

    return {
        name,
        fieldType: "buttonSelector",
        fieldOptions: {
            id,
            label,
            items,
            columnClass: "col-6",
            selectedClass: "selected-button",
            notSelectedClass: "not-selected-button",
            exclusive
        },
        validationSchema: {
            ...schema.properties[schemaName],
            required: schema.hasOwnProperty("required")
                ? schema.required.includes(name)
                : false
        },
        formSpacing: true,
        columnClass: "col-12",
        ...fieldOverrides
    };
}
